import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const MiniUpArrowIcon = withSvgIcon(
    <g>
        <polygon points="379,330.6 249,205.4 119,330.6 99.6,311.9 249,168 398.4,312     " />
    </g>
);
